import { render } from "./InputView.vue?vue&type=template&id=6ca26c25"
import script from "./InputView.vue?vue&type=script&lang=js"
export * from "./InputView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__